import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UserDatabases from '@Services/UserDatabases';
import AppStorage from '@Services/AppStorage';
import { TextArea } from '@els/els-react--text-input';
import QueryOptionsDropdown from '@Pages/QueryBuilder/QueryOptionsDropdown/QueryOptionsDropdown';
import { useDispatch } from 'react-redux';
import { updateStructureandAdvancedAction } from '../../../QueryletActions';

function Advanced({ advancedType }) {
  const ADVANCED_QUERYLET_SELECTED_DB = 'advancedQueryletSelectedDB';
  const anyDB = null;

  const [advancedData, setAdvancedData] = useState({
    data: { ...advancedType, databaseId: AppStorage.instance.get(ADVANCED_QUERYLET_SELECTED_DB) || anyDB },
    databases: [anyDB, ...UserDatabases.getListWithIds()],
  });
  const dispatch = useDispatch();

  useEffect(() => {
    setAdvancedData((prevData) => ({
      ...prevData,
      data: { ...advancedData.data, value: advancedType.value },
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancedType.value]);

  const onDBChange = (selectedDB) => {
    const dbId = !selectedDB || selectedDB !== -1 ? selectedDB : anyDB;
    setAdvancedData((prevData) => ({
      ...prevData,
      data: { ...advancedData.data, databaseId: dbId },
    }));
    AppStorage.instance.set(ADVANCED_QUERYLET_SELECTED_DB, dbId);
  };

  const updateAdvancedQuery = (value) => {
    setAdvancedData((prevData) => ({
      ...prevData,
      data: { ...advancedData.data, value },
    }));
  };

  useEffect(() => {
    dispatch(updateStructureandAdvancedAction(advancedData.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancedData.data]);

  return (
    <div className="advanced-type">
      <div className="ql__prop__form">
        <QueryOptionsDropdown queryOptionsType={advancedData} handleSelectOperation={onDBChange} type="advanced" node={advancedType} />
        <div className="ql__prop__form__input">
          <TextArea
            value={advancedData.data.value ? advancedData.data.value : ''}
            rows={2}
            shouldHideLabel
            label="Please enter advanced query here..."
            onChange={(e) => updateAdvancedQuery(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

Advanced.propTypes = {
  advancedType: PropTypes.object,
};

export default Advanced;
